const _assetRequires = require.context("@/legacy/resources/?url", true, /\..*?/);
const keys = _assetRequires.keys();


export default function load(loader) {
    loader.asset = function(path) {
        var name = "@asset:" + path;
        loader.module(name, [], async function __module_require_dynamic() {
            const {csrfLessClient: client} = await import("@/utils/http");
            const assetPath = `./${path}`;
            if (keys.includes(assetPath)) {
                const realPath = _assetRequires(`./${path}`);
                return (await client.get(realPath, {transformResponse: (r) => r, headers: {Accept: "*/*"}})).data;
            }

            const req = (await client.get(path, {transformResponse: (r) => r, headers: {Accept: "*/*"}}))
            return req.data
        }, true);
        return name;
    };
    loader.registerPreprocessor("asset", (_, args) => {
        return loader.asset(args);
    });
}
